import { css } from 'styled-components';
import { PINK, WHITE, PURPLE_LIGHT } from '../../../constants/colors';
import { media } from '../../../helpers/mixins';

export default {
  mask: css`
    overflow: hidden;
    background-color: ${PURPLE_LIGHT};
  `,
  wrapper: css`
    display: block;
    padding: 32px;

    ${media.switchHeaderToDesktop`
      padding: 0;
      margin-left: -20px;
      margin-right: -20px;
    `};

    .slick-list,
    .slick-slider,
    .slick-track {
      display:block;
      position:relative;
    }

    .slick-loading .slick-slide,
    .slick-loading .slick-track {
      visibility:hidden;
    }

    .slick-slider {
      box-sizing:border-box;
      user-select:none;
      -webkit-touch-callout:none;
      touch-action:pan-y;
      -webkit-tap-highlight-color:transparent;
      width: 100%;
    }

    .slick-list {
      overflow: visible;
      margin:0;
      padding:0;
    }

    .slick-list:focus {
      outline:0;
    }

    .slick-list.dragging {
      cursor:pointer;
      cursor:hand;
    }

    .slick-slider .slick-list,
    .slick-slider .slick-track {
      display: flex;
      transform:translate3d(0,0,0);

      ${media.switchHeaderToDesktop`
        transition-delay: 10ms;
      `};
    }
    .slick-slide > div{
      width:100%;
    }
    .slick-track {
      top:0;
      left:0;
    }

    .slick-track:after,
    .slick-track:before {
      display:table;
      content:'';
    }

    .slick-track:after {
      clear:both;
    }

    .slick-slide {
      display:none;
      float:left;
      height:100%;
      min-height:1px;
    }

    [dir=rtl] .slick-slide {
      float:right;
    }

    .slick-slide img {
      display:block;
    }

    .slick-slide.dragging img {
      pointer-events:none;
    }

    .slick-initialized .slick-slide {
      display: flex;
    }

    .slick-vertical .slick-slide {
      display:block;
      height:auto;
      border:1px solid transparent;
    }

    .slick-arrow.slick-hidden {
      display:none;
    }

    .slick-dots {
      display: flex !important;
      position: absolute;
      list-style-type: none;
      bottom: 16px;
      padding: 0;
      margin: 0;
      justify-content: center;
      width: 100%;

      li {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        &.slick-active button {
          background-color: ${WHITE};
          opacity: 1;
        }

        button {
          font-size: 0;
          outline: 0;
          padding: 0;
          height: 12px;
          width: 12px;
          border: 0;
          border-radius: 12px;
          background-color: white;
          cursor: pointer;
          opacity: 0.5;
        }
      }
    }
  `
};
